import * as Types from '../types';

export const createGDDashboardRepository = (getGDService: Types.GetGDService): Types.GDDashboardsRepository => ({
    async get(params) {
        const { dashboardId, product, testingWorkspaceId } = params;
        const { getBackend, getWorkspace } = await getGDService({ product });
        return getBackend()
            .workspace(testingWorkspaceId || getWorkspace() || '')
            .dashboards()
            .getDashboard({ identifier: dashboardId });
    },
    async getAll(params) {
        const { product, testingWorkspaceId, ...otherParams } = params;
        const { getBackend, getWorkspace } = await getGDService({ product });
        return getBackend()
            .workspace(testingWorkspaceId || getWorkspace() || '')
            .dashboards()
            .getDashboards({
                loadUserData: true,
                ...otherParams,
            });
    },
    async getPermissions(params) {
        const { dashboards, product, testingWorkspaceId } = params;
        const { getBackend, getWorkspace } = await getGDService({ product });

        if (!dashboards || dashboards.length === 0) {
            return {};
        }

        const permPromises = dashboards.map(async ({ identifier }) =>
            getBackend()
                .workspace(testingWorkspaceId || getWorkspace() || '')
                .dashboards()
                .getDashboardPermissions({ identifier })
                .catch(() => null)
        );
        const results = await Promise.all(permPromises);
        return Object.fromEntries(dashboards.map(({ identifier }, i) => [identifier, results[i]]));
    },
    async duplicate(params) {
        const { dashboard, product } = params;
        const { getBackend, getWorkspace } = await getGDService({ product });

        return getBackend()
            .workspace(getWorkspace() || '')
            .dashboards()
            .createDashboard(dashboard);
    },
    async delete(params) {
        const { dashboardId, product, testingWorkspaceId } = params;
        const { getBackend, getWorkspace } = await getGDService({ product });

        return getBackend()
            .workspace(testingWorkspaceId || getWorkspace() || '')
            .dashboards()
            .deleteDashboard({ identifier: dashboardId });
    },
});
